import BusinessSize from './businessDistribution'
import { Highlight } from './header/HightLight'
import Industry from './portfolioIndustry'
import Province from './portfolioProvince'
import YearOperation from './yearDistribution'

const Bottom = () => {
  return (
    <>
      <Highlight />
      <Province />
      <Industry />
      <BusinessSize />
      <YearOperation />
    </>
  )
}

export default Bottom
